<template>
  <a-modal
    :body-style="{ height: 'calc(100vh - 300px)', overflowY: 'scroll' }"
    width="1000px"
    :title="$t('po.detail_title')"
    :visible="visible"
    :closable="false"
  >
    <a-spin :spinning="isLoading" :tip="$t('po.loading_detail')">
      <a-descriptions :column="2" size="middle" bordered>
        <a-descriptions-item :label="$t('po.columns.number')">
          {{ form.poNumber || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('po.columns.po_date')">
          {{ formatDate(form.poDate) }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('po.columns.supplier_do')">
          {{ form.deliveryNumber || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('po.columns.delivery_date')">
          {{ formatDate(form.deliveryDate) }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('po.columns.supplier')">
          {{ form.supplierCode || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('po.columns.warehouse')">
          {{ form.warehouseId || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('po.columns.created_by')">
          {{ form.username || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('po.columns.created_at')">
          {{ formatDate(form.createdAt) }}
        </a-descriptions-item>
      </a-descriptions>
      <!-- Detail Item Produk -->
      <a-card :title="$t('adjustment.detailItem')" class="w-100 mt-4 po-detail-list" :bordered="false">
        <a-row :gutter="24">
          <a-col :span="24">
            <div>
              <div class="d-flex align-items-center justify-content-end mb-3">
                <div>{{ $t('returnReceived.totalSku') }}: <b>{{ itemList.length }}</b></div>
              </div>
              <a-table
                :columns="columns"
                :row-key="(record, index) => index"
                :data-source="itemList"
                :loading="isLoading"
                :pagination="false"
                :scroll="{ y: 330, x: 1100 }"
                bordered
              >
                <template slot="price" slot-scope="text">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">
                      IDR {{ toCurrency(text) }}
                    </div>
                  </div>
                </template>
                <template slot="catalog_id" slot-scope="text, record">
                  <div class="d-flex flex-column product-select">
                    <div>{{ record?.title }}</div>
                    <div class="sku-desc">
                      {{ 'SKU : ' + ellipsisText(record?.sku) }}
                    </div>
                  </div>
                </template>
                <template slot="batch_number" slot-scope="text">
                  {{ text || '-' }}
                </template>
                <template slot="expired_date" slot-scope="text">
                  <template v-if="text">
                    {{ $moment(text).format('DD MMM YYYY') }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </template>
                <template slot="qty" slot-scope="text">
                  <div>
                    {{ toCurrency(text) }}
                  </div>
                </template>
                <template slot="uom" slot-scope="text">
                  {{ text }}
                </template>
                <template slot="qty_received" slot-scope="text">
                  {{ text || '-' }}
                </template>
                <template slot="uom_received" slot-scope="text, record">
                  {{ record.base_uom || '-' }}
                </template>
                <template slot="base_quantity" slot-scope="text">
                  {{ text || '-' }}
                </template>
                <template slot="base_uom" slot-scope="text">
                  {{ text || '-' }}
                </template>
              </a-table>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-spin>
    <template #footer>
      <template>
        <a-button
          type="primary"
          :loading="fetchingDetailPO"
          @click="closeModal"
        >
          {{ $t('utils.close') }}
        </a-button>
      </template>
    </template>
  </a-modal>
</template>

<script>
import { getDetailPO } from '@/api/purchase-order'
import moment from 'moment'

export default {
  name: 'ModalDetailPO',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    businessId: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
    disableAutoFetch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateFormat: 'DD MMM YYYY',
      isLoading: false,
      fetchingDetailPO: false,
      form: {
        poNumber: undefined,
        deliveryNumber: undefined,
        poDate: undefined,
        deliveryDate: undefined,
        supplierCode: undefined,
        warehouseId: undefined,
        username: undefined,
        createdAt: undefined,
      },
      itemList: [],
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('fulfillment.product'),
          dataIndex: 'catalog_id',
          key: 'catalog_id',
          width: 250,
          scopedSlots: {
            customRender: 'catalog_id',
          },
        },
        {
          title: this.$t('utils.price'),
          dataIndex: 'price',
          key: 'price',
          width: 150,
          scopedSlots: {
            customRender: 'price',
          },
        },
        {
          title: 'Batch Number',
          dataIndex: 'batch_number',
          key: 'batch_number',
          width: 150,
          scopedSlots: {
            customRender: 'batch_number',
          },
        },
        {
          title: 'Expired Date',
          dataIndex: 'expired_date',
          key: 'expired_date',
          width: 150,
          scopedSlots: {
            customRender: 'expired_date',
          },
        },
        {
          title: this.$t('po.columns.detail_po'),
          children: [
            {
              title: this.$t('po.columns.qty_po'),
              dataIndex: 'qty',
              key: 'qty',
              width: 180,
              scopedSlots: {
                customRender: 'qty',
              },
            },
            {
              title: this.$t('po.columns.uom_po'),
              dataIndex: 'uom',
              key: 'uom',
              width: 190,
              scopedSlots: {
                customRender: 'uom',
              },
            },
          ],
        },
        {
          title: this.$t('inventory.goods_receipt.gr_detail'),
          children: [
            {
              title: this.$t('po.columns.qty_gr'),
              dataIndex: 'qty_received',
              key: 'qty_received',
              width: 100,
              scopedSlots: {
                customRender: 'qty_received',
              },
            },
            {
              title: this.$t('inventory.goods_receipt.uom_gr'),
              dataIndex: 'uom_received',
              key: 'uom_received',
              width: 100,
              scopedSlots: {
                customRender: 'uom_received',
              },
            },
          ],
        },
        {
          title: this.$t('inventory.goods_receipt.base_info'),
          children: [
            {
              title: this.$t('inventory.goods_receipt.base_qty'),
              dataIndex: 'base_quantity',
              key: 'base_quantity',
              width: 100,
              scopedSlots: {
                customRender: 'base_quantity',
              },
            },
            {
              title: this.$t('inventory.goods_receipt.base_uom'),
              dataIndex: 'base_uom',
              key: 'base_uom',
              width: 120,
              scopedSlots: {
                customRender: 'base_uom',
              },
            },
          ],
        },
      ]
    },
  },
  watch: {
    visible: {
      deep: true,
      immediate: false,
      handler(val) {
        if (val) {
          const hasDetails = Array.isArray(this?.data?.details)
          if (this.disableAutoFetch || hasDetails) {
            this.itemList = this.data?.details || []
            this.fetchingDetailPO = false
          } else {
            this.fetchDetailDataPO()
          }
          this.setFormData()
        }
      },
    },
  },
  methods: {
    setFormData() {
      this.form.poNumber = this.data.number
      this.form.deliveryNumber = this.data.supplier_do
      this.form.poDate = this.data.po_date
      this.form.deliveryDate = this.data.request_delivery_date
      this.form.supplierCode = this.data.supplier_code
      this.form.warehouseId = this.data.whs_name
      this.form.username = this.data.user_name || '-'
      this.form.createdAt = this.data.created_at
    },
    numberOnly(event) {
      const keyCode = (event.which) ? event.which : event.keyCode
      if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) event.preventDefault()
    },
    closeModal() {
      this.$emit('onCancel', false)
    },
    ellipsisText(text) {
      if(!text) return '-'
      return text.length > 29 ? `${text.substring(0, 26)}...` : text
    },
    toCurrency(value) {
      return `${Intl.NumberFormat('en-US').format(value || 0)}`
    },
    formatDate(value) {
      if (!value) return '-'
      try {
        return (this.$moment ? this.$moment(value) : moment(value)).format(this.dateFormat)
      } catch (e) {
        return value
      }
    },
    fetchDetailDataPO() {
      this.fetchingDetailPO = true
      getDetailPO({
        business_id: this.businessId,
        id: this.data.id,
      })
      .then(({ data }) => {
        this.itemList = data?.data?.details || []
        this.fetchingDetailPO = false
      })
      .catch(() => {
        this.fetchingDetailPO = false
      })
    },
  },
}
</script>

<style lang="scss" module>
</style>
<style lang="scss">
.po-detail-list .ant-card-body {
  padding: 24px 0 0 !important;
}
.image-spin {
  -webkit-animation:spin 4s linear infinite;
  -moz-animation:spin 4s linear infinite;
  animation:spin 4s linear infinite;
}
@-moz-keyframes spin { 
    100% { -moz-transform: rotate(360deg); } 
}
@-webkit-keyframes spin { 
    100% { -webkit-transform: rotate(360deg); } 
}
@keyframes spin { 
    100% { 
        -webkit-transform: rotate(360deg); 
        transform:rotate(360deg); 
    } 
}
</style>